import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import About from '@/views/About.vue'
import Projects from '@/views/Projects.vue'
import Gokul from '@/views/Gokul.vue'
import LogoStory from '@/views/LogoStory.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/projects',
    name: 'Projects',
    component: Projects
  },
  {
    path: '/logo',
    name: 'Logo',
    component: LogoStory
  },
  {
    path: '/gokul',
    name: 'Gokul',
    component: Gokul
  },
  // {
  //   path: '/contact',
  //   name: 'Contact',
  //   component: Contact
  // }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router 